export const STORE_MODULE_REVISIONS = "content/revisions";

export const STATE_REVISIONS = "revisions";
export const STATE_REVISIONS_LOADING = "loading";

export const ACTION_LOAD_REVISIONS = "loadRevisions";

export const MUTATION_SET_REVISIONS = "setRevisions";